import React from "react";
import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import Cover from "../../Components/GeneratePdf/Cover";
import TableContent from "../../Components/GeneratePdf/SelfReport/TableContent";
import Overview from "../../Components/GeneratePdf/SelfReport/Overview";
import AboutGroupReportFirst from "../../Components/GroupReport/AboutGroupReportFirst";
import AboutGroupReportSecond from "../../Components/GroupReport/AboutGroupReportSecond";
import HomeFirst from "../../Components/GeneratePdf/SelfReport/HomeFirst";
import FourQuadrantPage from "../../Components/GeneratePdf/SelfReport/FourQuadrantPage";
import GroupStarterQuadrantChart from "../../Components/GroupReport/GroupStarterQuadrantChart";
import GroupHeartStarter from "../../Components/GroupReport/GroupHeartStarter";
import GroupSoulStarter from "../../Components/GroupReport/GroupSoulStarter";
import QuadrantFlowHome from "../../Components/GeneratePdf/SelfReport/QuadrantFlowHome";
import GroupQuadrantFlowFirstPage from "../../Components/GroupReport/GroupQuadrantFlowFirstPage";
import GroupQuadrantFlowSecondPage from "../../Components/GroupReport/GroupQuadrantFlowSecondPage";
import GroupQuadrantFlowHeartToSoul from "../../Components/GroupReport/GroupQuadrantFlowHeartToSoul";
import GroupQuadrantFlowHeartToSoul2 from "../../Components/GroupReport/GroupQuadrantFlowHeartToSoul2";
import GroupQuadrantFlowHeartToSoul3 from "../../Components/GroupReport/GroupQuadrantFlowHeartToSoul3";
import GroupItemOverviewFirst from "../../Components/GroupReport/GroupItemOverviewFirst";
import GroupItemOverviewSecond from "../../Components/GroupReport/GroupItemOverviewSecond";
import HeartPage from "../../Components/GeneratePdf/HeartPage";
import SoulPage from "../../Components/GeneratePdf/SoulPage";
import MindPage from "../../Components/GeneratePdf/MindPage";
import StrengthPage from "../../Components/GeneratePdf/StrengthPage";
import LeadershipPage1 from "../../Components/GeneratePdf/Leadership/LeadershipPage1";
import LeadershipPage2 from "../../Components/GeneratePdf/Leadership/LeadershipPage2";
import GroupLeadershipChartOverview from "../../Components/GroupReport/GroupLeadershipChartOverview";
import GroupLeadershipStyleCollaborative from "../../Components/GroupReport/GroupLeadershipStyleCollaborative";
import GroupLeadershipFlow from "../../Components/GroupReport/GroupLeadershipFlow";
import GroupLeadershipCollaborativetoStrategic from "../../Components/GroupReport/GroupLeadershipCollaborativetoStrategic";
import GroupLeadershipFlowSeocnd from "../../Components/GroupReport/GroupLeadershipFlowSeocnd";
import GroupLeadershipCollaborativetoVisionary from "../../Components/GroupReport/GroupLeadershipCollaborativetoVisionary";
import GroupLeadershipVisionarytoCollaborative from "../../Components/GroupReport/GroupLeadershipVisionarytoCollaborative";
import GroupLeadershipItemOverview from "../../Components/GroupReport/GroupLeadershipItemOverview";
import GroupLeadershipItemOverviewSecond from "../../Components/GroupReport/GroupLeadershipItemOverviewSecond";
import CollaborativePage from "../../Components/GeneratePdf/Leadership/CollaborativePage";
import VisionaryPage from "../../Components/GeneratePdf/Leadership/VisionaryPage";
import StrategicPage from "../../Components/GeneratePdf/Leadership/StrategicPage";  
import PerformancePage from "../../Components/GeneratePdf/Leadership/PerformancePage";
import GapAnalysisPage from "../../Components/GeneratePdf/Leadership/GapAnalysisPage";
import GapAnalysisPageTwo from "../../Components/GeneratePdf/Leadership/GapAnalysisPageTwo";
import HomeMinset from "../../Components/GeneratePdf/SelfReport/HomeMinset";
import MindSetPage from "../../Components/GeneratePdf/MindSetPage";
import MindSetPage2 from "../../Components/GeneratePdf/MindSetPage2";
import MindSetPage3 from "../../Components/GeneratePdf/MindSetPage3";
import RelectAndIntegrate1 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate1";
import RelectAndIntegrate2 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate2";
import LifeIntegration1 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration1";
import LifeIntegration3 from "../../Components/GeneratePdf/SelfReport/LifeIntegration3";
import LifeIntegration2 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration2";
import snapshotGroupImg from "../../Assets/Images/snapshotGroupImg.png";
import snapshotSecondGroupImg from "../../Assets/Images/snapshotSecondGroupImg.png";
import { calculatePageNumbers } from "../../utils/helper";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 30,
  },
  page2: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 20,
  },
  pagespace: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 21,
    height: 792,
    justifyContent: "space-between",
  },
});

// Map menu keys to their corresponding pages for group assessment
const pageComponentMap = {
   "Cover Page": [
      { component: Cover, style: styles.page }
    ],
    "Table of Contents": [
      { component: (props) => <TableContent {...props} pageNumbers={calculatePageNumbers(props.menuItems, pageComponentMap)} />, style: styles.page }
    ],
    "Overview": [
      { component: Overview, style: styles.page }
    ],
  "Summary Snapshot": [
    { component: AboutGroupReportFirst, style: styles.page },
    { component: (props) => <AboutGroupReportSecond img={snapshotGroupImg} showNote={false} {...props} />, style: styles.page },
    { component: (props) => <AboutGroupReportSecond img={snapshotSecondGroupImg} showNote={true} {...props} />, style: styles.page }
  ],
  "Starter Quadrant": [
    { component: HomeFirst, style: styles.page }
  ],
  "Four Quadrants": [
    { component: FourQuadrantPage, style: styles.page },
  ],
  "Starter Quadrant Chart": [
    { component: (props) => <GroupStarterQuadrantChart showNote={false} {...props} />, style: styles.page },
    { component: (props) => <GroupStarterQuadrantChart showNote={true} {...props} />, style: styles.page },
  ],
  "Heart Starter" : [
    { component: GroupHeartStarter, style: styles.page },
  ],
  "Soul Starter" : [
    { component: GroupSoulStarter, style: styles.page }
  ],
  "HomeQuadrantFlow": [
    { component: QuadrantFlowHome, style: styles.page }
  ],
  "Introduction": [
    { component: GroupQuadrantFlowFirstPage, style: styles.page },
  ],
  "Quadrant Flow": [
    { component: GroupQuadrantFlowSecondPage, style: styles.page },
  ],
  "Heart To Soul": [
    { component: GroupQuadrantFlowHeartToSoul, style: styles.page },
    // { component: GroupQuadrantFlowHeartToSoul2, style: styles.page },
  ],
  "Soul To Heart": [
    { component: GroupQuadrantFlowHeartToSoul3, style: styles.page }
  ],
  "QFItemOnePage": [
    { component: GroupItemOverviewFirst, style: styles.page },
    { component: GroupItemOverviewSecond, style: styles.page }
  ],
   // Quadrant In Focus
   "Heart": [
    { component: HeartPage, style: styles.page },
  ],
  "Soul": [
    { component: SoulPage, style: styles.page },
  ],
  "Mind": [
    { component: MindPage, style: styles.page },
  ],
  "Strength": [
    { component: StrengthPage, style: styles.page }
  ],
  "Home Leadership Style": [
    { component: LeadershipPage1, style: styles.page },
  ],
  "Leadership Style Introduction": [
    { component: LeadershipPage2, style: styles.page },
  ],
  "Leadership Style Chart": [
    { component: (props) => <GroupLeadershipChartOverview showNote={false} showContent={true} {...props} />, style: styles.page },
    { component: (props) => <GroupLeadershipChartOverview showNote={true} showContent={false} {...props} />, style: styles.page },
  ],
  "Leadership Style Results": [
    { component: GroupLeadershipStyleCollaborative, style: styles.page }
  ],
  "Leadership Flow Introduction": [
    { component: GroupLeadershipFlow, style: styles.page },
    { component: GroupLeadershipFlowSeocnd, style: styles.page },
  ],
  "Leadership Flow": [
    { component: GroupLeadershipCollaborativetoStrategic, style: styles.page },
    { component: GroupLeadershipCollaborativetoVisionary, style: styles.page },
    { component: GroupLeadershipVisionarytoCollaborative, style: styles.page }
  ],
  "Leadership Items Overview": [
    { component: GroupLeadershipItemOverview, style: styles.page },
    { component: GroupLeadershipItemOverviewSecond, style: styles.page }
  ],
   // Leadership Style In Focus
    "Collaborative": [
      { component: CollaborativePage, style: styles.page },
    ],
    "Visionary": [
      { component: VisionaryPage, style: styles.page },
    ],
    "Strategic": [
      { component: StrategicPage, style: styles.page },
    ],
    "Performance": [
      { component: PerformancePage, style: styles.page }
    ],
  "Alignment": [
    { component: GapAnalysisPage, style: styles.page },
    { component: GapAnalysisPageTwo, style: styles.page }
  ],
   "Home Mindset": [
    { component: HomeMinset, style: styles.page },
    ],
    "Mindset Introduction": [
      { component: MindSetPage, style: styles.page },
      { component: MindSetPage2, style: styles.page },
    ],
    "Mindset Results": [
      { component: MindSetPage3, style: styles.page }
    ],
     // Reflect and Integrate Section
      "Home Reflect And Integrate": [
        { component: RelectAndIntegrate1, style: styles.page2 }
      ],
      "Reflect and Integrate": [
        { component: RelectAndIntegrate2, style: styles.page2 }
      ],
      "Life Integration": [
        { component: LifeIntegration1, style: styles.page2 }
      ],
      "Leadership Integration": [
        { component: LifeIntegration3, style: styles.page2 }
      ],
      "Final Thoughts": [
        { component: LifeIntegration2, style: styles.page2 }
      ]
};

export default function MyDocumentGroup({ apiData, menuItems }) {
  const findActiveMenuItems = (items) => {
    const activeItems = new Set();
    const processedItems = new Set(); 
    
    const processItem = (item) => {
      if (processedItems.has(item.key)) {
        return;
      }
      
      processedItems.add(item.key);

      if (item.isActive) {
        activeItems.add(item.key);
        
        if (item.subMenu) {
          item.subMenu.forEach(subItem => {
            if (!processedItems.has(subItem.key)) {
              activeItems.add(subItem.key);
              processItem(subItem);
            }
          });
        }
      } 
      else if (item.subMenu) {
        item.subMenu.forEach(subItem => processItem(subItem));
      }
    };

    items?.forEach(item => processItem(item));
    return Array.from(activeItems);
  };

  const renderPage = (key, config, index) => {
    try {
      const Component = config.component;
      return (
        <Page 
          key={`${key}-${index}`} 
          size={{ width: 612, height: 792 }} 
          style={config.style}
        >
          <Component apiData={apiData} menuItems={menuItems} />
        </Page>
      );
    } catch (error) {
      console.error(`Error rendering page ${key}:`, error);
      return null;
    }
  };
  const renderedPages = new Set();
  const pages = [
    <Page key="cover" size={{ width: 612, height: 792 }} style={styles.page}>
      <Cover apiData={apiData} />
    </Page>
  ];

  const activeMenuKeys = findActiveMenuItems(menuItems || []);

  activeMenuKeys.forEach(key => {
    const pageConfigs = pageComponentMap[key];
    
    if (pageConfigs) {
      pageConfigs.forEach((config, index) => {
        const pageKey = `${key}-${config.component.name}`;
        if (!renderedPages.has(pageKey)) {
          const page = renderPage(key, config, index);
          if (page) {
            pages.push(page);
            renderedPages.add(pageKey);
          }
        }
      });
    }
  });

  return (
    <Document>
      {pages}
    </Document>
  );
}